var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-content-mobileFull bg-grey3 radius-18" },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-top bg-grey3 radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
        },
        [
          _c(
            "button",
            {
              staticClass:
                "close rounded-btn display-3 p-0 bg-grey3 pull-right",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.modal.dismiss()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "font-lato text-light",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("×")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "modal-top--title fsize-18 color-grey1 text-bold xtext-uppercase radius-18 radius-bottom-0",
              },
              [
                _c("div", [
                  _vm._v("\n\t\t\t\t\tBon de commande\n\t\t\t\t\t"),
                  _vm.order.shop.info.salon.modeDevis
                    ? _c("span", [_vm._v("devis")])
                    : _c("span", [_vm._v("salon")]),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { id: "myForm" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.continuer()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column modal-main bg-grey3 radius-18 radius-top-0 pos-relative zindex-0",
              staticStyle: { "min-height": "400px" },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Siren / Siret "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.siren,
                            expression: "info2.siren",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: { width: "180px" },
                        attrs: { type: "text", list: "etablissements-list" },
                        domProps: { value: _vm.info2.siren },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.info2, "siren", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-btn" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default bg-white",
                            attrs: { title: "Chercher l'établissement" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.searchSiren()
                              },
                            },
                          },
                          [
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.sirenLoading,
                                  expression: "!sirenLoading",
                                },
                              ],
                              staticClass: "fa fa-search",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sirenLoading,
                                  expression: "sirenLoading",
                                },
                              ],
                              staticClass: "loading",
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "datalist",
                      { attrs: { id: "etablissements-list" } },
                      _vm._l(_vm.etablissements_list, function (e) {
                        return _c(
                          "option",
                          { key: e.siret, domProps: { value: e.siret } },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(e.denominationUniteLegale) +
                                "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(e.numeroVoieEtablissement) +
                                " " +
                                _vm._s(e.typeVoieEtablissement) +
                                " " +
                                _vm._s(e.libelleVoieEtablissement) +
                                "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(e.codePostalEtablissement) +
                                " " +
                                _vm._s(e.libelleCommuneEtablissement) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group flex-column flex-center-start" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Numéro client: "),
                      ]),
                      _vm._v(" "),
                      _c("editable-text", {
                        attrs: { required: true, value: _vm.info2.NumCli },
                        on: {
                          input: function ($event) {
                            _vm.info2.NumCli = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("TVA Intracom:"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.tvaIntracom,
                          expression: "info2.tvaIntracom",
                        },
                      ],
                      staticClass: "form-control",
                      staticStyle: { display: "inline-block", width: "150px" },
                      attrs: { type: "text" },
                      domProps: { value: _vm.info2.tvaIntracom },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.info2,
                            "tvaIntracom",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Société")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.company,
                          expression: "info2.company",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.company },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "company", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Nom")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.lastName,
                          expression: "info2.lastName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.lastName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "lastName", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Prénom")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.firstName,
                          expression: "info2.firstName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.firstName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "firstName", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Téléphone")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.mobile,
                          expression: "info2.mobile",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "", pattern: ".{5,}" },
                      domProps: { value: _vm.info2.mobile },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "mobile", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.email,
                          expression: "info2.email",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.email },
                      on: {
                        change: function ($event) {
                          return _vm.validateEmail()
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "email", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.emailError
                      ? _c("p", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.emailError)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Adresse")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.address,
                          expression: "info2.address",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.address },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "address", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Code Postal"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.zip,
                          expression: "info2.zip",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.zip },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "zip", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Ville")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info2.city,
                          expression: "info2.city",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.info2.city },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.info2, "city", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Pays")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.country,
                            expression: "info2.country",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "", id: "", required: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.info2,
                              "country",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.countries, function (country) {
                        return _c(
                          "option",
                          {
                            key: country.Country,
                            domProps: { value: country.Country },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(country.Country) +
                                "\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("TVA:")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "flex-start-center gap-2" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.vatPercent,
                            expression: "info2.vatPercent",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: { display: "inline-block", width: "50px" },
                        attrs: { type: "text" },
                        domProps: { value: _vm.info2.vatPercent },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.info2,
                              "vatPercent",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v("\n\t\t\t\t\t\t\t%\n\t\t\t\t\t\t"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Date du projet"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.dateProject,
                            expression: "info2.dateProject",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "date" },
                        domProps: { value: _vm.info2.dateProject },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.info2,
                              "dateProject",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Secteur d'activité"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.sector,
                            expression: "info2.sector",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "", id: "" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.info2,
                              "sector",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "Restaurant" } }, [
                          _vm._v("Restaurant"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Fast-Food" } }, [
                          _vm._v("Fast-Food"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Vente à emporter" } }, [
                          _vm._v("Vente à emporter"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Restaurant Gastronomique" } },
                          [_vm._v("Restaurant Gastronomique")]
                        ),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Boulangerie" } }, [
                          _vm._v("Boulangerie"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Autre" } }, [
                          _vm._v("Autre"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "switch mb-0" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
                        },
                        [_vm._v(" Signature électronique ? ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.useDocusign,
                            expression: "info2.useDocusign",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.info2.useDocusign)
                            ? _vm._i(_vm.info2.useDocusign, null) > -1
                            : _vm.info2.useDocusign,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.info2.useDocusign,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.info2,
                                    "useDocusign",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.info2,
                                    "useDocusign",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.info2, "useDocusign", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "slider bg-grey3 round" }),
                    ]),
                    _vm._v(" "),
                    _vm.info2.useDocusign
                      ? _c("p", [
                          _vm._v(
                            "Le devis à signer sera envoyé à l'email " +
                              _vm._s(_vm.info2.email)
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            "Le devis à signer ne sera pas envoyé au client"
                          ),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Commentaire sur le devis"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.notes,
                            expression: "info2.notes",
                          },
                        ],
                        staticClass: "w-100",
                        attrs: { name: "", id: "", cols: "30", rows: "10" },
                        domProps: { value: _vm.info2.notes },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.info2, "notes", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Commercial")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.info2.commercialEmail,
                            expression: "info2.commercialEmail",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "", id: "", required: "" },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.info2,
                                "commercialEmail",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.commercialChange,
                          ],
                        },
                      },
                      _vm._l(
                        _vm.order.shop.info.salon.commercials,
                        function (c) {
                          return _c(
                            "option",
                            { key: c.email, domProps: { value: c.email } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(c.name) +
                                  " (" +
                                  _vm._s(c.email) +
                                  ")\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row-form" }, [
                  !_vm.order.client
                    ? _c(
                        "a",
                        {
                          staticClass: "text-danger",
                          attrs: { href: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.UiService.showClientLoginModal(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\tVous n'êtes pas connecté; Cliquez ici pour vous connecter\n\t\t\t\t\t"
                          ),
                        ]
                      )
                    : _c("div", [
                        _vm._v(
                          "Connecté en tant que " +
                            _vm._s(_vm.order.client.FirstName) +
                            " " +
                            _vm._s(_vm.order.client.LastName) +
                            " (" +
                            _vm._s(_vm.order.client.Email) +
                            ")"
                        ),
                      ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c("div", { staticClass: "flex-center-center" }, [
        _c(
          "button",
          {
            staticClass: "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
            attrs: { type: "submit", form: "myForm" },
          },
          [_vm._v("Confirmer")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }